
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { searchCustomer } from "@/api/customer";
import {
  getClosingOrderInfo,
  getNotion,
  closingOrderCheckSubmit,
  getClosureType,
  putClosingOrder,
  getRelateOrderId,
  postCheck,
  invalidClosureOrder,
  revertClosureOrder,
  getMixInventory,
  deleteMixInventory,
  getPiInfoModel,
  postPiInfo,
  getCustomsPacking,
  customsPackingSet,
  getAllInventory, getPiIdByCl, checkAdjustInventory, resetPackingToInventory,
} from "@/api/closing-order";
import { debounce } from "lodash";
import SpecifyInventory from "@/views-oms/closing-position/components/specifyInventory.vue";
import EditInvoice from "@/views/invoice/component/EditInvoice.vue";
import Template from "@/views/system-management/template/index.vue";
@Component({
  name: "allocateInventory",
  components: {
    Template,
    SpecifyInventory,
    SpecialInventory: SpecifyInventory,
    Pagination,
  },
})
export default class extends Vue {
  @Prop({ default: null }) private id: null;
  @Prop({ default: null }) private type: null;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };

  private piInfoTable = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };
  private listParam = {
    model: null,
    hqProductName: null,
    pageNumber: 1,
    pageSize: 20,
  };
  private PIProductParam = {
    modelKeyword: null,
    existInfoIds: [],
    pageNumber: 1,
    pageSize: 20,
  };

  private AppointProductParam = {
    model: null,
  };

  private isShow1 = false;
  private isShow2 = false;

  private showCheckSuccess = false;
  private checkSuccessContent = "";
  private showCheckFail = false;
  private checkFailContent = "";
  private showEditDetail = false;
  private editDetailContent = "";
  private showWithdrawOrder = false;
  private withdrawOrder = "";
  private showCancelOrder = false;
  private showCancelOrderContent = "";

  private showLookAllocatedInventory = false;

  private showAppointProduct = false;
  private showEditAppointProduct = false;

  private showAddPIProduct = false;

  private stateBackList = [];
  private stateBackInfo = null;

  private infoFields = [
    {
      label: "平仓单编号",
      prop: "code",
      key: "code",
    },
    {
      label: "平仓单生成时间",
      prop: "createdAt",
      key: "createdAt",
    },
    {
      label: "当前状态",
      prop: "stateDesc",
      key: "stateDesc",
    },
    {
      label: "平仓类型",
      prop: "typeDesc",
      key: "typeDesc",
      resetKey: { value: "name", label: "desc" },
      options: [],
    },
    {
      label: "公司类型",
      prop: "company",
      key: "company",
      type: "select",
      resetKey: { value: "name", label: "desc" },
      options: [
        { name: "HQ", desc: "华强" },
        { name: "JR", desc: "嘉锐" },
      ],
      span: 2
    },
    {
      label: "调出客人信息",
      prop: "customerId1",
      key: "customerId1",
      remote_method: this.getCustomer1,
      remote: true,
      type: "select",
      resetKey: { value: "id", label: "abbreviation" },
      options: [],
      filterable: true,
    },
    {
      label: "调入客人信息",
      prop: "customerId",
      key: "customerId",
      remote_method: this.getCustomer,
      remote: true,
      type: "select",
      resetKey: { value: "id", label: "abbreviation" },
      options: [],
      filterable: true,
    },
    {
      label: "关联单据类型",
      prop: "relateType1",
      key: "relateType1",
      type: "select",
      resetKey: { value: "name", label: "desc" },
      options: [],
      disabled: true,
    },
    {
      label: "关联单据类型",
      prop: "relateType",
      key: "relateType",
      type: "select",
      resetKey: { value: "name", label: "desc" },
      options: [],
      disabled: true,
    },
    // select_multiple
    // 单选返回数组 别问 问就是 sb
    {
      label: "装箱单号",
      prop: "orderId1",
      key: "orderId1",
      type: "select_multiple",
      indexKey: "orderId",
      collapseTags: false,
      resetKey: { value: "orderId", label: "code" },
      options: [],
      remote: true,
      clearable: true,
      multiple: true,
      remote_method: this.getRelateOrderIdMAIN,
    },
    {
      label: "关联单据号",
      prop: "orderId",
      key: "orderId",
      type: "select_returnArr",
      collapseTags: false,
      indexKey: "orderId",
      resetKey: { value: "orderId", label: "code" },
      options: [],
      remote: true,
      clearable: true,
      remote_method: this.getRelateOrderIdOUT,
    },
    {
      label: "工厂简称",
      prop: "factoryName",
      key: "factoryName",
    },
    {
      label: "指定进仓单",
      prop: "deliveryNoteId",
      key: "deliveryNoteId",
      type: "select",
      resetKey: { value: "orderId", label: "code" },
      options: [],
      remote: true,
      clearable: true,
      remote_method: this.getDeliveryNoteId,
    },
    {
      label: "平仓说明",
      prop: "remark",
      key: "remark",
      type: "textarea",
    },
    {
      label: "注意事项",
      prop: "important",
      key: "important",
    }
  ] as any;
  public checkResult = "" as any;
  private info = {
    code: null,
    createdAt: null,
    state: null,
    type: null,
    company: null,
    customerId: null,
    relateCode: "",
    relateType: null,
    customerId1: null,
    relateCode1: [],
    relateType1: null,
    remark: null,
    important: null,
    orderId1: [],
    orderId: "",
    factoryName: "",
    deliveryNoteId: ''
  } as any;
  private searchForm = [
    {
      label: "号码查询",
      prop: "model",
      key: "model",
      type: "input",
      value: "",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
    },
    {
      label: "装箱单",
      prop: "packingListCode",
      key: "packingListCode",
      type: "input",
      value: "",
    },
  ];
  private tableCol = [
    {
      label: "PI号码",
      prop: "piCode",
      key: "piCode",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "询价参照号",
      prop: "refNumber",
      key: "refNumber",
      show: true,
      disabled: false,
    },
    {
      label: "H&Q交易号码",
      prop: "hqTransactionNo",
      key: "hqTransactionNo",
      show: true,
      disabled: false,
    },
    {
      label: "客人号码",
      prop: "customerNo",
      key: "customerNo",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "HQ号码",
      prop: "hqNo",
      key: "hqNo",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "OE号码",
      prop: "oeNo",
      key: "oeNo",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "REF号码",
      prop: "refNo",
      key: "refNo",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "接单数量",
      prop: "shipmentQty",
      key: "shipmentQty",
      show: true,
      disabled: false,
    },
    {
      label: "下单数量",
      prop: "deliveryQty",
      key: "deliveryQty",
      show: true,
      disabled: false,
    },
    {
      label: "在库数量",
      prop: "availableQty",
      key: "availableQty",
      show: true,
      disabled: false,
    },
    {
      label: "平仓后在库数量",
      prop: "expectQty",
      key: "expectQty",
      show: true,
      disabled: false,
    },
    {
      label: "调配库存产品总数量",
      prop: "processedQty",
      key: "processedQty",
      show: true,
      disabled: false,
    },
    {
      label: "库存主包装编号",
      prop: "packingCode",
      key: "packingCode",
      show: true,
      disabled: false,
    },
    {
      label: "库存主包装数量",
      prop: "packingQty",
      key: "packingQty",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "删除",
          code: "",
          click: "oneDelete",
        },
        {
          name: "指定库存",
          code: "",
          click: "designatedInventory"
        },
      ],
      show: true,
      disabled: false,
      width: 200,
    },
  ] as any;
  private tableCol1 = [
    {
      label: "PI号码",
      prop: "piCode",
      key: "piCode",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "询价参照号",
      prop: "refNumber",
      key: "refNumber",
      show: true,
      disabled: false,
    },
    {
      label: "H&Q交易号码",
      prop: "hqTransactionNo",
      key: "hqTransactionNo",
      show: true,
      disabled: false,
    },
    {
      label: "客人号码",
      prop: "customerNo",
      key: "customerNo",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "HQ号码",
      prop: "hqNo",
      key: "hqNo",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "OE号码",
      prop: "oeNo",
      key: "oeNo",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "REF号码",
      prop: "refNo",
      key: "refNo",
      show: true,
      disabled: false,
      show_key: "show2",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "接单数量",
      prop: "shipmentQty",
      key: "shipmentQty",
      show: true,
      disabled: false,
    },
    {
      label: "下单数量",
      prop: "deliveryQty",
      key: "deliveryQty",
      show: true,
      disabled: false,
    },
    {
      label: "在库数量",
      prop: "availableQty",
      key: "availableQty",
      show: true,
      disabled: false,
    },
    {
      label: "平仓后在库数量",
      prop: "expectQty",
      key: "expectQty",
      show: true,
      disabled: false,
    },
    {
      label: "调配库存产品总数量",
      prop: "processedQty",
      key: "processedQty",
      show: true,
      disabled: false,
    },
    {
      label: "库存主包装编号",
      prop: "packingCode",
      key: "packingCode",
      show: true,
      disabled: false,
    },
    {
      label: "库存主包装数量",
      prop: "packingQty",
      key: "packingQty",
      show: true,
      disabled: false,
    },
    {
      label: "取消指定库存备注",
      prop: "resetRemark",
      key: "resetRemark",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "查看已分配库存",
          code: "",
          click: "lookAllocatedInventory"
        },
      ],
      show: true,
      disabled: false,
      width: 200,
    }
  ] as any;
  private PIProductSearchForm = [
    {
      label: "号码查询",
      prop: "modelKeyword",
      key: "modelKeyword",
      type: "input",
      value: "",
    },
  ];
  private AppointProductSearchForm = [
    {
      label: "号码查询",
      prop: "model",
      key: "model",
      type: "input",
      value: "",
    },
  ];
  private PIProductList = [];
  private AppointProductList = [];
  private AppointProductList1 = [];
  private EditAppointProductList = [];
  private PIProductCol = [
    {
      label: "客人型号",
      prop: "customerNumber",
      key: "customerNumber",
      show: true,
      disabled: false,
    },
    {
      label: "HQ交易号码",
      prop: "hqTransactionNumber",
      key: "hqTransactionNumber",
      show: true,
      disabled: false,
    },
    {
      label: "REF",
      prop: "refNumber",
      key: "refNumber",
      show: true,
      disabled: false,
    },
    {
      label: "OE",
      prop: "oeNumber",
      key: "oeNumber",
      show: true,
      disabled: false,
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "报关品名",
      prop: "declarationName",
      key: "declarationName",
      show: true,
      disabled: false,
    }
  ] as any;
  private AppointProductColYes = [
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
    },
    {
      label: "装箱单号",
      prop: "packingList",
      key: "packingList",
      show: true,
      disabled: false,
    },
    {
      label: "客人号码",
      prop: "guestModel",
      key: "guestModel",
      show: true,
      disabled: false,
    },
    {
      label: "华强号码",
      prop: "hqOrJrNumber",
      key: "hqOrJrNumber",
      show: true,
      disabled: false,
    },
    {
      label: "OE号码",
      prop: "oeNumber",
      key: "oeNumber",
      show: true,
      disabled: false,
    },
    {
      label: "REF号码",
      prop: "refNumber",
      key: "refNumber",
      show: true,
      disabled: false,
    },
    {
      label: "主包装编号",
      prop: "packingCode",
      key: "packingCode",
      show: true,
      disabled: false
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "报关品名",
      prop: "declarationDescription",
      key: "declarationDescription",
      show: true,
      disabled: false,
    },
    {
      label: "体积M3",
      prop: "volume",
      key: "volume",
      show: true,
      disabled: false,
    },
    {
      label: "净重",
      prop: "nw",
      key: "nw",
      show: true,
      disabled: false,
    },
    {
      label: "毛重",
      prop: "gw",
      key: "gw",
      show: true,
      disabled: false,
    },
    {
      label: "总金额",
      prop: "totalAmount",
      key: "totalAmount",
      show: true,
      disabled: false,
    },
    {
      label: "产品总数量",
      prop: "totalQty",
      key: "totalQty",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单号",
      prop: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
      show: true,
      disabled: false,
    },
    {
      label: "采购价格",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "创建时间",
      prop: "createdAt",
      key: "createdAt",
      show: true,
      disabled: false,
    }
  ] as any;
  private AppointProductCol = [
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
    },
    {
      label: "装箱单号",
      prop: "hqPackingCode",
      key: "hqPackingCode",
      show: true,
      disabled: false,
    },
    {
      label: "客人号码",
      prop: "guestModel",
      key: "guestModel",
      show: true,
      disabled: false,
    },
    {
      label: "华强号码",
      prop: "hqOrJrNumber",
      key: "hqOrJrNumber",
      show: true,
      disabled: false,
    },
    {
      label: "OE号码",
      prop: "oeNumber",
      key: "oeNumber",
      show: true,
      disabled: false,
    },
    {
      label: "REF号码",
      prop: "refNumber",
      key: "refNumber",
      show: true,
      disabled: false,
    },
    {
      label: "主包装编号",
      prop: "customPackingGroup",
      key: "customPackingGroup",
      show: true,
      disabled: false,
      type: "link",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "报关品名",
      prop: "declarationDescription",
      key: "declarationDescription",
      show: true,
      disabled: false,
    },
    {
      label: "体积M3",
      prop: "volume",
      key: "volume",
      show: true,
      disabled: false,
    },
    {
      label: "净重",
      prop: "netWeight",
      key: "netWeight",
      show: true,
      disabled: false,
    },
    {
      label: "毛重",
      prop: "grossWeight",
      key: "grossWeight",
      show: true,
      disabled: false,
    },
    {
      label: "总金额",
      prop: "totalPurchaseAmount",
      key: "totalPurchaseAmount",
      show: true,
      disabled: false,
    },
    {
      label: "产品总数量",
      prop: "totalNumberPcs",
      key: "totalNumberPcs",
      show: true,
      disabled: false,
    },
    {
      label: "主包装数量",
      prop: "customsPaclingQuantity",
      key: "customsPaclingQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单号",
      prop: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
      show: true,
      disabled: false,
    },
    {
      label: "采购价格",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "创建时间",
      prop: "createdAt",
      key: "createdAt",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "编辑明细",
          code: "",
          click: "editDetail",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    }
  ] as any;
  private EditAppointProductCol = [
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
    },
    {
      label: "装箱单号",
      prop: "hqPackingCode",
      key: "hqPackingCode",
      show: true,
      disabled: false,
    },
    {
      label: "型号",
      prop: "model",
      key: "model",
      show: true,
      disabled: false,
    },
    {
      label: "主包装编号",
      prop: "customPackingGroup",
      key: "customPackingGroup",
      show: true,
      disabled: false,
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "报关品名",
      prop: "declarationDescription",
      key: "declarationDescription",
      show: true,
      disabled: false,
    },
    {
      label: "体积M3",
      prop: "volume",
      key: "volume",
      show: true,
      disabled: false,
    },
    {
      label: "净重",
      prop: "netWeight",
      key: "netWeight",
      show: true,
      disabled: false,
    },
    {
      label: "毛重",
      prop: "grossWeight",
      key: "grossWeight",
      show: true,
      disabled: false,
    },
    {
      label: "总金额",
      prop: "totalPurchaseAmount",
      key: "totalPurchaseAmount",
      show: true,
      disabled: false,
    },
    {
      label: "产品总数量",
      prop: "totalNumberPcs",
      key: "totalNumberPcs",
      show: true,
      disabled: false,
    },
    {
      label: "主包装数量",
      prop: "customsPaclingQuantity",
      key: "customsPaclingQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单号",
      prop: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
      show: true,
      disabled: false,
    },
    {
      label: "采购价格",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "创建时间",
      prop: "createdAt",
      key: "createdAt",
      show: true,
      disabled: false,
    },
  ] as any;
  private relateOrders = {};
  private getClosureTypeList = [];
  private AssignedInventoryList = [] as any;
  private AssignedInventoryCol = [
    {
      label: "体积M3",
      prop: "volume",
      key: "volume",
      show: true,
      disabled: false,
    },
  ] as any;
  private AssignedInventoryLoading = false;
  mounted() {
    this.init();
  }
  private async init() {
    await this.getCustomer();
    await this.getCustomer1();
    await this.getClosureType();
    await this.getDet();
    await this.getMixInventory();
  }

  // 查看已分配库存-移除
  private removeAssignedInventory() {
    if (
      this.selectRowsAssignedInventory &&
      this.selectRowsAssignedInventory.length > 0
    ) {
      this.selectRowsAssignedInventory.map((ex) => {
        if (this.AllInventory.findIndex((it) => it.id === ex.id) !== -1) {
          this.AllInventory.splice(
            this.AllInventory.findIndex((it) => it.id === ex.id),
            1
          );
        }
      });
      this.$confirm("确定移除已分配的库存吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // let newArr = [];
          // newArr = this.AllInventory
          let data = {
            customsPackingIds: this.AllInventory.map((ex) => {
              return ex.id;
            }),
            piInfoId: this.selectAppointProductId,
          };
          await customsPackingSet(this.id, data)
            .then(async (res) => {
              this.$notify({
                title: "提示",
                message: "移除已分配的库存成功",
                type: "success",
                duration: 2000,
              });
              (
                this.$refs.AssignedInventoryTab as any
              ).$refs.table.clearSelection();
              this.loading = true;
              await getCustomsPacking(this.id, this.AppointProductParam)
                .then((res: any) => {
                  this.AppointProductList = res;
                  this.loading = false;
                })
                .catch((err) => {
                  console.log(err);
                  this.loading = false;
                });
              this.AssignedInventoryLoading = true;
              await getAllInventory(
                this.id,
                this.selectAppointProductId
              ).then(ress => {
                this.AllInventory = ress;
                this.AssignedInventoryLoading = false;
              }).catch(err =>{
                console.log(err);
                this.AssignedInventoryLoading = false;
              })
              await this.getMixInventory()
            })
            .catch((err) => {
              console.log(err);
              console.log(
                "selectRowsAssignedInventory",
                this.selectRowsAssignedInventory
              );
              this.AllInventory = [
                ...this.AllInventory,
                ...this.selectRowsAssignedInventory,
              ];
              (
                this.$refs.AssignedInventoryTab as any
              ).$refs.table.clearSelection();
            });
        })
        .catch((err) => {
          console.error(err);
        });
      (this.$refs.AssignedInventoryTab as any).$refs.table.clearSelection();
    } else {
      this.$notify({
        title: "提示",
        message: "请选择数据！",
        type: "warning",
        duration: 2000,
      });
    }
  }
  private async addToinventory() {
    let newKeys = Object.keys(this.selectionChangeProALL);
    let newArr = [];
    newKeys.map((er) => {
      newArr = [...newArr, ...this.selectionChangeProALL[er]];
    });
    newArr = [...newArr, ...this.AllInventory];
    if (newArr.length === 0) {
      this.$notify({
        title: "提示",
        message: "请选择数据",
        type: "warning",
        duration: 2000,
      });
      return;
    }
    let data = {
      customsPackingIds: newArr.map((ex) => {
        return ex.id;
      }),
      piInfoId: this.selectAppointProductId,
    };
    await customsPackingSet(this.id, data)
      .then(async (res) => {
        this.initInventory();
        this.$notify({
          title: "提示",
          message: "添加到库存成功",
          type: "success",
          duration: 2000,
        });
        (this.$refs.selectionChangeProFA as any).$refs.table.clearSelection();
        this.loading = true;
        await getCustomsPacking(this.id, this.AppointProductParam)
          .then((res: any) => {
            this.AppointProductList = res;
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
          (this.$refs.selectionChangeProFA as any).$refs.table.clearSelection();
          this.loading = true;
          await getCustomsPacking(this.id, this.AppointProductParam)
            .then((res: any) => {
              this.AppointProductList = res;
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
          this.AssignedInventoryLoading = true;
          await getAllInventory(
            this.id,
            this.selectAppointProductId
          ).then(ress => {
            this.AllInventory = ress;
            this.AssignedInventoryLoading = false;
          }).catch(err => {
            console.log(err);
            this.AssignedInventoryLoading = false;
          })
          await this.getMixInventory()
        })
        .catch((err) => {
          console.log(err);
          this.selectionChangeProALL = {} as any;
          (this.$refs.selectionChangeProFA as any).$refs.table.clearSelection();
        });
  }

  private lookAllocatedInventoryLoading = false;
  private curRowPiInfoId = '';
  private async lookAllocatedInventory(row) {
    this.lookAllocatedInventoryLoading = true;
    this.showLookAllocatedInventory = true;
    this.curRowPiInfoId = row.row.id;
    await getAllInventory(this.id, row.row.id).then(ress => {
      this.AppointProductList1 = ress as any;
      this.lookAllocatedInventoryLoading = false;
    }).catch(err => {
      console.log(err);
      this.lookAllocatedInventoryLoading = false;
    })
  }

  private selectRowsAssignedInventory = [] as any;
  // 查看已分配库存-勾选
  private onSelectionAssignedInventory(rows) {
    this.selectRowsAssignedInventory = [];
    this.selectRowsAssignedInventory = rows;
  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.infoFields[
      this.infoFields.findIndex((e) => e.key === "customerId")
    ].options = res;
  }
  private async getCustomer1(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.infoFields[
      this.infoFields.findIndex((e) => e.key === "customerId1")
    ].options = res;
  }
  public loading: Boolean = false;
  private async getMixInventory() {
    this.loading = true;
    const res: any = await getMixInventory(this.id, this.listParam);
    this.table.list = res.content;
    this.table.total = res.total;
    this.table.pageNumber = res.pageNumber;
    this.table.pageSize = res.pageSize;
    // 获取列表时，对于已经添加piInfo中的数据，将id添加到existInfoIds中
    this.table.list.map((e) => {
      this.PIProductParam.existInfoIds.push(e.id);
    });
    this.loading = false;
  }

  private async getClosureType() {
    const res: any = await getClosureType();
    this.infoFields[
      this.infoFields.findIndex((e) => e.key === "typeDesc")
    ].options = res;
    this.getClosureTypeList = res;
  }
  public querySearch(data) {
    this.listParam = { ...this.listParam, ...data };
    this.getMixInventory();
  }

  private PIProductQuerySearch(data) {
    this.PIProductParam = {...this.PIProductParam,  ...data};
    this.AddPIProductBtn();
  }

  private async AppointProductQuerySearch(data) {
    this.loading = true;
    this.AppointProductParam = Object.assign({}, data);
    const res: any = await getCustomsPacking(this.id, this.AppointProductParam);
    this.AppointProductList = res;
    this.loading = false;
  }

  private AllInventory = [] as any;

  private async designatedInventory(row) {
    this.loading = true;
    this.selectAppointProductId = row.row.id;
    await getCustomsPacking(this.id, {
      supplierId: row.row.supplier,
      hqProductName: row.row.hqProductName
    })
      .then((res: any) => {
        this.loading = false;
        (this.$refs['specifyInventoryRef'] as SpecifyInventory).openDialog(
            this.id,
            row.row,
            res)
      })
      .catch((err) => {
        console.error(err);
        this.loading = false;
      });
    this.AssignedInventoryLoading = true;
    await getAllInventory(this.id, row.row.id).then(ress => {
      this.AllInventory = ress;
      this.AssignedInventoryLoading = false;
    }).catch(err => {
      console.log(err);
      this.AssignedInventoryLoading = false;
    })
  }

  private async getDeliveryNoteId(name) {
    let newArr = [] as any;
    this.info.relateOrders.map((e) => {
      // 这里说明一下为什么是 type 为 OUT
      // 因为新建的时候进仓单没有传customerId 之前是公用的PI的 所以现在 直接吧PI的拿过来使用了
      // 代码的改来改去的很麻烦 就这么用了
      // 为了让之后看懂所以加个注释 望海涵
      if (e.relateType === "OUT") {
        newArr.push(e);
      }
    });
    if (newArr.length > 0 && newArr[0].customer && name) {
      let params = {
        code: name,
        customerId: newArr[0].customer,
        company: this.info.company,
        orderType: 'DELIVERY_NOTE',
      };
      const res: any = await getRelateOrderId(params);
      this.infoFields.find(e => e.key === 'deliveryNoteId').options = res
    } else {
      this.$notify({
        title: "提示",
        message: "请先选择调入客人信息！",
        type: "warning",
        duration: 2000,
      });
    }
  }

  private editDetail(row) {
    this.EditAppointProductList = row.row.customsPackingResList;
    this.selectionChangeProFACode = row.row.id;
    this.showEditAppointProduct = true;
  }

  private async getDet() {
    this.initCodelist();
    let params = {
      type: this.type,
    };
    const ress: any = await getNotion(params);
    const res: any = await getClosingOrderInfo(this.id);
    this.info = Object.assign(this.info, res);
    res.relateOrders.map((item) => {
      if (item.relateType === "MAIN") {
        this.info.relateCode1.push(item.code);
        this.info.orderId1.push(item.orderId);
        this.infoFields
          .find((ex) => ex.key === "orderId1")
          .options.push({
            code: item.code,
            orderId: item.orderId,
          });
        this.codeList1.push({
          code: item.code,
          orderId: item.orderId,
        });
        this.info.customerId1 = item.customer;
      }
    });
    let factoryNameList = []
    res.relateOrders.filter(e => e.orderType === 'HQ_PACKING_LIST').map(item => {
      if (item.factoryName) {
        factoryNameList.push(item.factoryName)
      }
    })
    this.info.factoryName = factoryNameList.toString()
    res.relateOrders.map((item) => {
      if (item.relateType === "OUT") {
        // this.info.relateCode.push(item.code);
        this.info.relateCode = item.code;
        this.info.orderId = item.orderId;
        this.infoFields
          .find((ex) => ex.key === "orderId")
          .options.push({
            code: item.code,
            orderId: item.orderId,
          });
        if (item.factoryName) {
          this.info.factoryName += item.factoryName + ",";
        }
        this.codeList.push({
          code: item.code,
          orderId: item.orderId,
        });
        this.info.customerId = item.customer;
      }
    });
    res.relateOrders.filter(e => e.relateType === "DELIVERY").map(async item => {
      await this.getDeliveryNoteId(item.code);
      this.$set(this.info,'deliveryNoteId',item.orderId)
    })
    this.info.relateType1 = "HQ_PACKING_LIST";
    this.info.relateType = "PI";
    this.info.important = ress.notion;
    this.infoFields[
      this.infoFields.findIndex((e) => e.key === "relateType1")
    ].options = [{ desc: "装箱单", name: "HQ_PACKING_LIST" }];
    this.infoFields[
      this.infoFields.findIndex((e) => e.key === "relateType")
    ].options = [{ desc: "PI", name: "PI" }];
  }

  private async getRelateOrderIdOUT(code = null) {
    let params = {
      code: code,
      customerId: this.info.customerId,
      company: this.info.company,
      orderType: this.info.relateType,
    };
    const res: any = await getRelateOrderId(params);
    let newArr = [...this.codeList, ...res];
    console.log("去重之前的数组", newArr);
    this.infoFields[
      this.infoFields.findIndex((ex) => ex.key === "orderId")
    ].options = this.Deduplication(newArr);
  }

  private async getRelateOrderIdMAIN(code = null) {
    let params = {
      code: code,
      customerId: this.info.customerId1,
      company: this.info.company,
      orderType: this.info.relateType1,
    };
    const res: any = await getRelateOrderId(params);
    let newArr = [...this.codeList1, ...res];
    this.infoFields[
      this.infoFields.findIndex((ex) => ex.key === "orderId1")
    ].options = this.Deduplication(newArr);
  }
  private Deduplication(arr) {
    for (var i = 0; i < arr.length; i++) {
      for (var j = i + 1; j < arr.length; j++) {
        if (arr[i].orderId == arr[j].orderId) {
          arr.splice(j, 1); //第一个等同于第二个，splice方法删除第二个
          j--;
        }
      }
    }
    return arr;
  }

  private changeValue({ key, value }) {
    console.log("走选择了吗", { key, value });
    if (key === "type") {
      if (value) {
        if (this.getClosureTypeList.findIndex((it) => it.name === value) > -1) {
          this.infoFields[
            this.infoFields.findIndex((x) => x.key === "relateType")
          ].options =
            this.getClosureTypeList[
              this.getClosureTypeList.findIndex((it) => it.name === value)
            ].allowOrders;
        }
      }
    }
    if (key === "orderId") {
      this.info.orderId = value;
      let newArr =
        this.infoFields[this.infoFields.findIndex((ex) => ex.key === "orderId")]
          .options;
      this.info.relateCode = newArr.find((ew) => ew.code === value).code;
    }
    if (key === "orderId1") {
      this.info.orderId1 = value;
      let newArr =
        this.infoFields[
          this.infoFields.findIndex((ex) => ex.key === "orderId1")
        ].options;
      this.info.relateCode1 = newArr.find((ew) => ew.code === value).code;
    }
    if (key === "type") {
      this.info.type = value;
    }
    if (key === "company") {
      this.info.company = value;
    }
    if (key === "customerId") {
      this.info.customerId = value;
      this.info.orderId = []
      this.info.deliveryNoteId = null
      this.infoFields.find(e => e.key === 'orderId').options = []
      this.infoFields.find(e => e.key === 'deliveryNoteId').options = []
    }
    if (key === "relateType") {
      this.info.relateType = value;
    }
    if (key === "customerId1") {
      this.info.customerId1 = value;
      this.info.orderId1 = []
      this.infoFields.find(e => e.key === 'orderId1').options = []
    }
    if (key === "relateType1") {
      this.info.relateType1 = value;
    }
    if (key === "deliveryNoteId") {
      this.$set(this.info, 'deliveryNoteId', value)
      console.log("this.info.deliveryNoteId", this.info.deliveryNoteId);
    }
  }
  public loading1: Boolean = false;
  private async AddPIProductBtn() {
    this.loading1 = true;
    this.showAddPIProduct = true;
    // 处理直接返回id，被识别并转换为数字，导致精度问题前端自主修改id。
    let piId = BigInt(await getPiIdByCl(this.id));
    try {
      const res: any = await getPiInfoModel(piId, this.PIProductParam);
      this.piInfoTable.list= res.list;
      this.piInfoTable.total = Number(res.total);
      this.piInfoTable.pageNumber = Number(res.page);
      this.piInfoTable.pageSize = Number(res.size);
    }catch (e) {
      console.error(e);
    }finally {
      this.loading1 = false;
    }
  }

  private allDelete() {
    if (this.selectRows.length === 0) {
      this.$notify({
        title: "提示",
        message: "请选择数据！",
        type: "warning",
        duration: 2000,
      });
    } else {
      this.$confirm("确定删除这些数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = this.selectRows.map((ex) => {
            this.clearPiInfoId(ex.id)
            return ex.id;
          });
          await deleteMixInventory(this.id, data)
            .then((res) => {
              this.$notify({
                title: "成功",
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
              (this.$refs.table as any).$refs.table.clearSelection();
              this.getMixInventory();
            })
            .catch((err) => {
              (this.$refs.table as any).$refs.table.clearSelection();
              console.log(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  private clearPiInfoId(piInfoId:string) {
    this.PIProductParam.existInfoIds = this.PIProductParam.existInfoIds
        .filter((item) => item !== piInfoId);
  }

  private oneDelete(row) {
    this.$confirm("确定删除此条数据吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let data = [row.row.id];
        this.clearPiInfoId(row.row.id);
        await deleteMixInventory(this.id, data)
          .then((res) => {
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
            this.getMixInventory();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private codeList = [];
  private codeList1 = [];

  private changeValueMultiple({ key, value, item }) {
    if (key === "orderId") {
      this.codeList = item.filter(Boolean);
      console.log("codeList", this.codeList);
    }
    if (key === "orderId1") {
      this.codeList1 = item.filter(Boolean);
    }
  }

  private revertClosureOrder() {
    this.$confirm("确定撤回平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        // let data = {
        //   id: this.info.id,
        //   // reason: this.withdrawOrder
        // };
        await revertClosureOrder(this.info.id)
          .then((res) => {
            this.getDet();
            this.showWithdrawOrder = false;
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private invalidClosureOrder() {
    this.$confirm("确定作废平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let data = {
          id: this.info.id,
          reason: this.showCancelOrderContent,
        };
        await invalidClosureOrder(data)
          .then((res) => {
            this.getDet();
            this.showCancelOrder = false;
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
          })
          .catch((err) => {
            console.log(err);
          });
        this.getDet();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async submitEdit() {
    let newArr = [this.info.orderId].map((item) => {
      return {
        customer: this.info.customerId,
        orderId: item,
        type: this.info.relateType,
        relateType: "OUT"
      };
    });
    let newArrDELIVERY = [this.info.orderId].map((item) => {
      return {
        orderId: this.info.deliveryNoteId,
        type: 'DELIVERY_NOTE',
        relateType: "DELIVERY",
      };
    });
    let newArr1 = this.info.orderId1.map((item) => {
      return {
        customer: this.info.customerId1,
        orderId: item,
        type: this.info.relateType1,
        relateType: "MAIN",
      };
    });
    let data = {
      id: this.info.id,
      company: this.info.company,
      remark: this.info.remark,
      relateOrders: [...newArr, ...newArr1, ...newArrDELIVERY],
    };
    try {
      let infoIds = newArr1.map((item) => {
        return item.orderId;
      });
      let piId = newArr[0].orderId;
      let deliveryNoteId = newArrDELIVERY[0].orderId;
      await checkAdjustInventory(this.info.id, piId, deliveryNoteId,infoIds);
    } catch (e) {
      console.error(e);
    }
    await putClosingOrder(data)
      .then((res) => {
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        this.getDet();
        this.showEditDetail = false;
      })
      .catch((err) => {
        console.log(err);
        this.showEditDetail = false;
      });
    this.showEditDetail =false;
  }

  private initCodelist() {
    this.codeList = [];
    this.codeList1 = [];
    this.info = {
      code: null,
      createdAt: null,
      state: null,
      type: null,
      company: null,
      customerId: null,
      relateCode: "",
      relateType: null,
      customerId1: null,
      relateCode1: [],
      relateType1: null,
      remark: null,
      important: null,
      orderId1: [],
      orderId: "",
    } as any;
  }

  private showAddPIProductClose() {
    (this.$refs.piTable as any).$refs.table.clearSelection();
    this.showAddPIProduct = false;
  }

  private showAddPIProductSubmit() {
    // fix debounce this 指向对象错误
    this.showAddPIProductSubmit0.call(this);
    this.selectPiProductRows.forEach((ex) => {
      this.PIProductParam.existInfoIds.push(ex);
    })
  }
  private showAddPIProductSubmit0 = debounce(function () {
    if (this.selectPiProductRows.length > 0) {
      let data = {
        closureOrderId: this.id,
        piInfoIds: this.selectPiProductRows.map((ex) => {
          return ex.id;
        }),
      };
      postPiInfo(data)
        .then((res) => {
          this.$notify({
            title: "提示",
            message: "添加PI产品成功",
            type: "success",
            duration: 2000,
          });
          (this.$refs.piTable as any).$refs.table.clearSelection();
          this.getMixInventory();
          this.showAddPIProduct = false;
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.$notify({
        title: "提示",
        message: "请选择数据！",
        type: "warning",
        duration: 2000,
      });
    }
  },1000);

  private selectRows = [];
  private selectPiProductRows = [];
  private selectionChangeProFA = []; // 指定库存
  private selectionChangeProFACode = ""; // 指定库存code
  private selectionChangeProSON = [] as any; // 主包装明细

  private selectionChangeProALL = {} as any; // 选中的主包装明细

  private onSelectionChange(rows) {
    this.selectRows = [];
    this.selectRows = rows;
  }

  private onSelectionChangePiProduct(rows) {
    this.selectPiProductRows = [];
    this.selectPiProductRows = rows;
  }

  private initInventory() {
    this.selectionChangeProFA = []; // 指定库存
    this.selectionChangeProFACode = ""; // 指定库存code
    this.selectionChangeProSON = [] as any; // 主包装明细
    this.selectionChangeProALL = {} as any;
  }

  private onSelectionChangeProFA(rows) {
    this.selectionChangeProFA = [];
    this.selectionChangeProFA = rows;
    rows.map((ex) => {
      this.selectionChangeProALL[ex.id] = ex.customsPackingResList;
    });
  }

  private onSelectionChangeProSON(rows) {
    this.selectionChangeProSON = [];
    this.selectionChangeProSON = rows;
  }

  private showEditAppointProductSubmit() {
    if (this.info.state === "CREATE") {
      this.showEditAppointProduct = false;
      this.selectionChangeProALL[this.selectionChangeProFACode] =
        this.selectionChangeProSON;
      if (
        this.selectionChangeProSON.length ===
        this.AppointProductList.find(
          (ex) => ex.id === this.selectionChangeProFACode
        ).customsPackingResList.length
      ) {
        (this.$refs.selectionChangeProFA as any).$refs.table.toggleRowSelection(
          this.AppointProductList.find(
            (ex) => ex.id === this.selectionChangeProFACode
          ),
          true
        );
      } else {
        (this.$refs.selectionChangeProFA as any).$refs.table.toggleRowSelection(
          this.AppointProductList.find(
            (ex) => ex.id === this.selectionChangeProFACode
          ),
          false
        );
      }
      (this.$refs.selectionChangeProSON as any).$refs.table.clearSelection();
    } else {
      this.showEditAppointProduct = false;
    }
  }

  private showEditAppointProductClose() {
    this.showEditAppointProduct = false;
    (this.$refs.selectionChangeProSON as any).$refs.table.clearSelection();
  }

  public selectAppointProductId = "";

  private async showAppointProductSubmit() {
    if (this.info.state === "CREATE") {
      let newKeys = Object.keys(this.selectionChangeProALL);
      let newArr = [];
      newKeys.map((er) => {
        newArr = [...newArr, ...this.selectionChangeProALL[er]];
      });
      newArr = [...newArr, ...this.AllInventory];
      let data = {
        customsPackingIds: newArr.map((ex) => {
          return ex.id;
        }),
        piInfoId: this.selectAppointProductId,
      };
      await customsPackingSet(this.id, data)
        .then((res) => {
          this.showAppointProduct = false;
          this.initInventory();
          this.$notify({
            title: "提示",
            message: "指定库存成功",
            type: "success",
            duration: 2000,
          });
          (this.$refs.selectionChangeProFA as any).$refs.table.clearSelection();
          this.getMixInventory();
        })
        .catch((err) => {
          console.log(err);
          (this.$refs.selectionChangeProFA as any).$refs.table.clearSelection();
          this.getMixInventory();
        });
    } else {
      this.showAppointProduct = false;
    }
  }

  private async postCheckMixInventory() {
    let newArr = [this.info.orderId].map((item) => {
      return {
        customer: this.info.customerId,
        orderId: item,
        type: this.info.relateType,
        relateType: "OUT"
      };
    });
    let newArrDELIVERY = [this.info.orderId].map((item) => {
      return {
        orderId: this.info.deliveryNoteId,
        type: 'DELIVERY_NOTE',
        relateType: "DELIVERY",
      };
    });
    let newArr1 = this.info.orderId1.map((item) => {
      return {
        customer: this.info.customerId1,
        orderId: item,
        type: this.info.relateType1,
        relateType: "MAIN",
      };
    });
    let data = {
      id: this.info.id,
      relateOrders: [...newArr, ...newArr1, ...newArrDELIVERY],
    };
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      await postCheck(data)
        .then((res) => {
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000,
          });
          this.getDet();
          this.checkResult = res.data ? res.data : "操作成功";
          this.showCheckSuccess = true;
          loading.close();
        })
        .catch((error) => {
          this.checkResult =
            error.response.data.message || error.response.data || error.message;
          loading.close();
        });
    } catch (err) {
      console.log("返回的err", err);
      loading.close();
    }
  }

  // private async postCheckMixInventory() {
  //   try {
  //     await postCheckMixInventory(this.id)
  //       .then((res) => {
  //         this.$notify({
  //           title: "成功",
  //           message: "操作成功",
  //           type: "success",
  //           duration: 2000,
  //         });
  //         this.getDet();
  //         this.checkResult = res.data?res.data:'操作成功';
  //         this.showCheckSuccess = true;
  //       })
  //       .catch((error) => {
  //         this.checkResult =
  //           error.response.data.message || error.response.data || error.message;
  //       });
  //   } catch (err) {
  //     console.log("返回的err", err);
  //   }
  // }

  private async closingOrderCheckSubmit() {
    let newArr = [this.info.orderId].map((item) => {
      return {
        customer: this.info.customerId,
        orderId: item,
        type: this.info.relateType,
        relateType: "OUT",
      };
    });
    let newArr1 = this.info.orderId1.map((item) => {
      return {
        customer: this.info.customerId1,
        orderId: item,
        type: this.info.relateType1,
        relateType: "MAIN",
      };
    });
    let newArrDELIVERY = [this.info.orderId].map((item) => {
      return {
        orderId: this.info.deliveryNoteId,
        type: 'DELIVERY_NOTE',
        relateType: "DELIVERY",
      };
    });
    let data = {
      id: this.info.id,
      relateOrders: [...newArr, ...newArr1, ...newArrDELIVERY],
    };
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    await closingOrderCheckSubmit(data)
      .then((res) => {
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        this.getDet();
        this.getMixInventory();
        this.showCheckSuccess = false;
        loading.close();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  private async searchCustomer(name = "") {
    // const res: any = await searchCustomer({ keyword: name });
    // this.searchForm[0].options = res;
  }
  private resetPackingIds = [];
  private resetRemark = '';
  private resetPopoverDivisible = false;
  private resetInventorySelectChange(rows) {
    this.resetPackingIds  =  [];
    this.resetPackingIds = rows.map((item) => item.packingId);
  }

  private async resetInventory() {
    if (this.resetPackingIds.length === 0) {
      this.$message.warning("请选择要删除的库存");
      return;
    }
    if (this.resetRemark.length === 0) {
      this.$message.warning("请填写删除原因");
      return;
    }
    await resetPackingToInventory(this.id, this.curRowPiInfoId,this.resetRemark, this.resetPackingIds)
        .then(() => {
          this.resetPopoverDivisible = false;
          this.showLookAllocatedInventory = false;
        })
    await this.getMixInventory();
  }
}
